var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userFooter-container"},[_c('button',[_vm._v("首页")]),_c('button',[_vm._v("上一页")]),_c('button',[_vm._v("下一页")]),_c('button',[_vm._v("末页")])])
}]

export { render, staticRenderFns }